import api from "../api/api";
import IBoeModel from "../interfaces/IBoeModel";
import ILoiModel from "../interfaces/ILoiModel";
import { IReportFile } from "../interfaces/IReportFile";

export default class ReportsApiService {
    async boe(model: IBoeModel): Promise<IReportFile> {
        const response = await api.post("/report/boe", model, { responseType: "blob" });

        const contentDisposition = (response.headers["content-disposition"] as string) || "";
        const filename = (contentDisposition.split("filename=")[1]?.split(";")[0] || "BOE.xlsx").replace(/^["']|["']$/g, "");

        return {
            name: filename,
            data: response.data,
        }
    }
    async loi(model: ILoiModel): Promise<IReportFile> {
        const response = await api.post("/report/loi", model, { responseType: "blob" });

        const contentDisposition = (response.headers["content-disposition"] as string) || "";
        const filename = (contentDisposition.split("filename=")[1]?.split(";")[0] || "LOI.docx").replace(/^["']|["']$/g, "");

        return {
            name: filename,
            data: response.data,
        }
    }
}